import jQuery from 'jquery';
import { throttle } from 'throttle-debounce';
import "@styles/core.scss";

(($, msg) => {
    $(() => {
        // ALL: WINDOW RESIZE LISTENER (THROTTLED)
        let width = $(window).width(),
            height = $(window).height(),
            windowsize;
        const $navControl = $('.o-header__nav-controller'),
            $navContainer = $('.o-header__nav'),
            navControlClass = 'o-header__nav-controller--open',
            navClass = 'o-header__nav--open',
            $header = $('.o-header'),
            headerOpen = 'o-header--open',
            $html = $('html'),
            $socialShare = $('.o-podcast .o-podcast__social').hide(),
            $podcastEmbed = $('.o-podcast__embed');

        $podcastEmbed.after($socialShare.html());

        const sizeCheck = () => {
            if ($(window).width() != width || $(window).height() != height) {
                $navControl.removeClass(navControlClass);
                $navContainer.removeClass(navClass);
                $header.removeClass(headerOpen);
            }
            windowsize = $(window).width();
            if (windowsize > 1099) {
                $('li.menu-item-has-children > a').removeClass('active');
                $('.sub-menu').removeClass('sub-menu--open');
                return false;
            }

            /**
             * Make first menu item click show submenu before navigating to new page.
             */
            $('li.menu-item-has-children > a').on('click touch', function (e) {
                const self = $(this);
                const href = self.attr('href');
                const doToggle = !href || href === '#';

                if (!self.is('.active') || doToggle) {
                    e.preventDefault();
                    self.toggleClass('active');
                    self.siblings('.sub-menu').toggleClass('sub-menu--open');
                }
            });
        };

        // Get Submenu li class names that contain `a-icon---*`, remove that class name and apply it to the child a tag. This moves the icon into the anchor link and there makes the entire submenu item clickable.
        $('.sub-menu li[class*="a-"]').each(function (i, el) {
            const name = (el.className.match(/(^|\s)(a\-icon\-\-[^\s]*)/) || [, , ''])[2];
            if (name) {
                $(el).removeClass(name).find('a').first().addClass(name);
            }
        });

        //Check if user scrolls
        const scrollCheck = () => {
            const addRemove = $(window).scrollTop() >= 50 ? 'add' : 'remove';
            $header[`${addRemove}Class`]('o-header--scroll');
            if ($header.hasClass('o-header--transparent')) {
                $header[`${addRemove}Class`]('o-header--dark');
            }
        };

        $(window).on('resize', throttle(500, sizeCheck)).on('scroll', throttle(250, scrollCheck));

        // Header > Nav controller
        $navControl.on('click touch', () => {
            $navControl.toggleClass(navControlClass);
            $navContainer.toggleClass(navClass);
            $header.toggleClass(headerOpen);
        });

        //window size check
        sizeCheck();

        let enableCall = true;
        // Inputs, update value attribute on keyup event
        $('.a-input-field input').on('keyup', function () {
            if (!enableCall) return;
            enableCall = false;

            let input = $(this).val();
            $(this).attr('value', input);

            /* THROTTLING RESIZE EVENT */
            setTimeout(() => (enableCall = true), 500);
        });

        const gravityForms = () => {
            // Gravity Forms Labels
            $('label.gfield_label').each(function () {
                let label = $(this);
                let label_text = label.text();
                label.addClass('a-input-field__placeholder-text');
                const label_filling = label.html('<div class="a-input-field__text">' + label_text + '</div>');
                label.parent('.gfield').find('.ginput_container').prepend(label_filling);
            });

            // Gravity Forms Input & Textarea::Focus & Focusout
            $('.gform_body input, .gform_body textarea').each(function () {
                let input = $(this);
                input
                    .on('focus', () => {
                        $(this).siblings('.a-input-field__placeholder-text').find('.a-input-field__text').addClass('active');
                    })
                    .on('focusout', () => {
                        if (!$(this).val()) {
                            $(this).siblings('.a-input-field__placeholder-text').find('.a-input-field__text').removeClass('active');
                        }
                    });

                // On validation, if check if field has value and if it does reapply active class to label text
                if (input.val()) {
                    $(this).siblings('.a-input-field__placeholder-text').find('.a-input-field__text').addClass('active');
                }
            });

            // Gravity Forms Fileupload Inputs - remove helper text
            $('.gform_body .ginput_container_fileupload').each(function () {
                let fileUpload = $(this);
                fileUpload.parent('.gfield').find('label').addClass('a-input-field__fileupload');
            });
        };

        gravityForms();

        // When "Apply Now" button is clicked scroll to gform_2 aka Apply Now form. Or when any anchor link is used.
        $('a[href^="#"].wp-block-button__link, .a-button--apply-now a').on('click tap', function (e) {
            e.preventDefault();

            const targetEle = this.hash;
            const $targetEle = $(targetEle);

            $('html, body')
                .stop()
                .animate(
                    {
                        scrollTop: $targetEle.offset().top - 80,
                    },
                    750,
                    'swing'
                );
        });

        /**
         * Open sidebar form on click of ask an advisor button
         */
        const $sidebarForm = $('#flyout-sidebar');
        $('.a-button--sidebar-flyout').on('click tap', (e) => {
            /** Prevent jump to top of page */
            e.preventDefault();
            e.stopPropagation();
            $sidebarForm.addClass('o-sidebar-flyout--open');
            /** prevent html from scrolling */
            $html.addClass('overflow-hidden');
        });

        /**
         * Open calendly on click of schedule a meeting button
         */
        const $calendlyForm = $('#schedule-meeting-calendly');
        $('.a-button--calendly').on('click tap', (e) => {
            /** Prevent jump to top of page */
            e.preventDefault();
            e.stopPropagation();
            $calendlyForm.addClass('o-calendly--open');
            /** prevent html from scrolling */
            $html.addClass('overflow-hidden');
        });

        /**
         * Open search overlay on click of search icon in the primary nav on desktop
         */
        const $searchForm = $('#search-overlay');
        $('#search-icon').on('click tap', (e) => {
            /** Prevent jump to top of page */
            e.preventDefault();
            e.stopPropagation();
            $searchForm.addClass('o-search-overlay--open');
            /** prevent html from scrolling */
            $html.addClass('overflow-hidden');
        });

        /**
         * Close Items
         */
        $(document).on('click touch keyup keydown', (e) => {
            /**
             * Close sidebar form if active and user clicks elsewhere or esc key is hit
             */
            if (e.target.matches('.o-sidebar-flyout--open') || e.target.matches('.o-sidebar-flyout__trigger') || e.key === 'Escape') {
                $sidebarForm.removeClass('o-sidebar-flyout--open').delay(150);
                $html.removeClass('overflow-hidden');
            }

            /**
             * Close calendly form if active and user clicks elsewhere or esc key is hit
             */
            if (e.target.matches('.o-calendly--open') || e.target.matches('.o-calendly__trigger') || e.key === 'Escape') {
                $calendlyForm.removeClass('o-calendly--open').delay(150);
                $html.removeClass('overflow-hidden');
            }

            /**
             * Close search overlay form if active and user clicks elsewhere or esc key is hit
             */
            if (e.target.matches('.o-search-overlay--open') || e.target.matches('.o-search-overlay__trigger') || e.key === 'Escape') {
                $searchForm.removeClass('o-search-overlay--open').delay(150);
                $html.removeClass('overflow-hidden');
            }
        });

        // Accordions
        $('.m-accordion .m-accordion__check').on('change', function () {
            $(this).parent().toggleClass('active');
        });

        // Fire the gravityForms function whenever gravity forms reloads on validation.
        jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
            // code to trigger on form or form page render
            gravityForms();
        });
    });
})(jQuery, 'frontend ready');

//non-jquery Fittext.js implementation
//https://github.com/adactio/FitText.js/blob/master/fittext.js
(function () {
    var addEvent = function (el, type, fn) {
        if (el.addEventListener) el.addEventListener(type, fn, false);
        else el.attachEvent('on' + type, fn);
    };

    var extend = function (obj, ext) {
        for (var key in ext) if (ext.hasOwnProperty(key)) obj[key] = ext[key];
        return obj;
    };

    window.fitText = function (el, kompressor, options) {
        var settings = extend(
            {
                minFontSize: -1 / 0,
                maxFontSize: 1 / 0,
            },
            options
        );

        var fit = function (el) {
            var compressor = kompressor || 1;

            var resizer = function () {
                el.style.fontSize = Math.max(Math.min(el.clientWidth / (compressor * 10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)) + 'px';
            };

            // Call once to set.
            resizer();

            // Bind events
            // If you have any js library which support Events, replace this part
            // and remove addEvent function (or use original jQuery version)
            addEvent(window, 'resize', resizer);
            addEvent(window, 'orientationchange', resizer);
        };

        if (el.length) for (var i = 0; i < el.length; i++) fit(el[i]);
        else fit(el);

        // return set of elements
        return el;
    };
})();
